import {Card, CardContent, CardHeader, CardTitle} from '@common-web/components/ui/card';
import {Badge} from '@common-web/components/ui/badge';
import {CheckCircle, Loader2} from 'lucide-react';

import {trpc} from '@common-web/lib/trpc';

const PHASE_LABELS: Record<string, string> = {
  INITIAL_SETUP: 'Initial Setup',
  PRE_ENROLLMENT: 'Pre-Enrollment',
  ENROLLMENT: 'Enrollment',
  GO_LIVE_PREP: 'Go Live Prep',
  POST_LAUNCH: 'Post Launch',
};

export function OnboardingPipelineCard({rfcId}: {rfcId: string}) {
  const {data, isLoading} = trpc.internal.onboarding.getOnboardingByRfc.useQuery({
    rfcSubmissionId: rfcId,
  });

  if (isLoading) {
    return (
      <Card className='border-gray-200 shadow-sm'>
        <CardHeader className='bg-gray-50 border-b'>
          <CardTitle className='text-lg font-semibold text-brand-navy'>
            Onboarding Pipeline
          </CardTitle>
        </CardHeader>
        <CardContent className='p-6'>
          <div className='flex items-center justify-center py-4'>
            <Loader2 className='h-5 w-5 animate-spin text-gray-400' />
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!data) return null;

  return (
    <Card className='border-gray-200 shadow-sm'>
      <CardHeader className='bg-gray-50 border-b'>
        <CardTitle className='text-lg font-semibold text-brand-navy'>
          Onboarding Pipeline
        </CardTitle>
      </CardHeader>
      <CardContent className='p-6'>
        <div className='space-y-3'>
          {data.phases.map((phase) => {
            const isComplete = phase.status === 'completed';
            const isInProgress = phase.status === 'in_progress';
            return (
              <div key={phase.phase} className='flex items-center space-x-3'>
                <CheckCircle
                  className={`h-5 w-5 ${isComplete ? 'text-emerald' : isInProgress ? 'text-blue-500' : 'text-gray-300'}`}
                />
                <span
                  className={
                    isComplete
                      ? 'font-medium text-brand-navy'
                      : isInProgress
                        ? 'font-medium text-blue-600'
                        : 'text-brand-gray'
                  }
                >
                  {PHASE_LABELS[phase.phase] ?? phase.phase}
                </span>
                {isInProgress && (
                  <Badge variant='outline' className='text-xs text-blue-600 border-blue-300'>
                    In Progress
                  </Badge>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
